export default __webpack_public_path__ + "static/media/keystatements.be46bcd3.webp";